import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { InlineSVGModule } from 'ng-inline-svg-2'
import { MenuItem } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { MenuModule } from 'primeng/menu'
import { AppUserRoleEnum } from '../../shared/models/enums/app-user-role.enum'
import { AppConfigService } from '../../shared/services/app-config.service'

@Component({
   selector: 'topbar',
   templateUrl: './topbar.component.html',
   changeDetection: ChangeDetectionStrategy.OnPush,
   standalone: true,
   imports: [MenuModule, ButtonModule, InlineSVGModule, TranslateModule]
})
export class TopbarComponent {
   @Input() userName?: string | null
   @Input() userRole?: AppUserRoleEnum | null

   items?: MenuItem[]

   @Output() logout = new EventEmitter()
   @Output() goToMyProjects = new EventEmitter()
   @Output() goToEditAccount = new EventEmitter()
   @Output() goToCreateProject = new EventEmitter()
   @Output() goToChangePassword = new EventEmitter()

   constructor(private _configService: AppConfigService) {}

   ngOnChanges(): void {
      if (this.userName) {
         this.initMenuItems()
      }
   }

   goToPMPHome() {
      window.open(this._configService.pmpHomeUrl, '_blank')
   }

   private initMenuItems() {
      this.items = [
         {
            label: 'My projects',
            icon: 'pi pi-briefcase app-toolbar-icon',
            command: () => {
               this.goToMyProjects.emit()
            }
         }
      ]

      if (this.userRole == AppUserRoleEnum.ADMIN) {
         this.items.push({
            label: 'Create new project',
            icon: 'pi pi-plus app-toolbar-icon',
            command: () => {
               this.goToCreateProject.emit()
            }
         })
      }

      if (this.userRole == AppUserRoleEnum.BASE) {
         this.items.push(
            {
               label: 'Change password',
               icon: 'pi pi-lock app-toolbar-icon',
               command: () => {
                  this.goToChangePassword.emit()
               }
            },
            {
               label: 'Edit account',
               icon: 'pi pi-user app-toolbar-icon',
               command: () => {
                  this.goToEditAccount.emit()
               }
            }
         )
      }

      this.items.push({
         label: 'Logout',
         icon: 'pi pi-sign-out app-toolbar-icon',
         command: () => {
            this.logout.emit()
         }
      })
   }
}
